var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { verifySignature } from "./olmlib";
/**
 * Sign an object (obj) with the users ed25519 key
 */
export function signObject(client, obj) {
    return __awaiter(this, void 0, void 0, function* () {
        yield client.crypto.signObject(obj);
    });
}
/**
 * Verifies whether the signature on obj (obj.signature) is valid.
 * This validates:
 * - Whether the object has been created by the Matrix user
 *    (by checking the signature with that user's public key)
 * - Whether that user has access to the room (this is delegated to matrixMemberReader)
 *
 * Throws an error if invalid
 */
export function verifyObject(client, memberReader, obj, eventTypeAccessRequired) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!obj.signatures || Object.keys(obj.signatures).length !== 1) {
            throw new Error("invalid signature");
        }
        const userId = Object.keys(obj.signatures)[0];
        if (!memberReader.hasWriteAccess(userId, eventTypeAccessRequired)) {
            throw new Error("user doesn't have write access");
        }
        const keyToGet = Object.keys(obj.signatures[userId])[0];
        if (!keyToGet.startsWith("ed25519:")) {
            throw new Error("unexpected key");
        }
        const deviceToGet = keyToGet.substr("ed25519:".length);
        client.crypto.deviceList.startTrackingDeviceList(userId);
        const keys = yield client.crypto.deviceList.downloadKeys([userId]);
        const deviceKey = keys[userId][deviceToGet].keys[keyToGet];
        if (!deviceKey) {
            throw new Error("key not found");
        }
        // This throws an error if it's invalid
        yield verifySignature(client.crypto.olmDevice, obj, userId, deviceToGet, deviceKey);
    });
}
//# sourceMappingURL=authUtil.js.map